// extracted by mini-css-extract-plugin
module.exports = {"Form":"Form--1Xr9I","Row":"Row--3lSmv","ChartSelector":"ChartSelector--1TiKR"};